import axios from "axios";
import { API_URLS } from "../constants/ApiUrls";

export const fetchAllFeedback = async (userId: string) => {
    const response = await axios.get(`${API_URLS.FEEDBACK}/user/${userId}`);
    if (response.status === 200)
        return response.data;
    return [];
}

export const createFeedback = async (request: any) => {
    const response = await axios.post(API_URLS.FEEDBACK, request);
    if (response.status === 200)
        return response.data;
    return null;
}